import en from "./locales/en";
import th from "./locales/th";

console.log("lang", localStorage.getItem("lang"));
export default {
  en,
  th,
};
